<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>
<div class="dashboard-container" *ngIf="!isSpinner">
  <nz-card class="card-body">
    <div class="dashboard-wrapper">
      <span>{{'dashboard' |translate}}</span>
      <nz-table nzTemplateMode class="dashboard-table" [attr.lang]="currentLang" [nzTableLayout]="narrowLayout ? 'fixed' : 'auto'">
          <thead>
            <tr>
              <th class="chapter-col" [nzWidth]="columnWidth('chapter')"></th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'questions' |translate |titlecase}}</th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'correct' |translate}}</th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'wrong' |translate}}</th>
              <th class="stat-col stat-unanswered" [nzWidth]="columnWidth('unanswered')">{{'unanswered' |translate}}</th>
              <th class="stat-col stat-percent" [nzWidth]="columnWidth('percent')">{{'percentCorrect' |translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of capitalTableList; let i = index">
              <td class="chapter-col"><b>{{i+1}}.</b> {{data.name}}</td>
              <td class="stat-col">{{data.total_question}}</td>
              <td class="stat-col">{{data.correct_question_count}}</td>
              <td class="stat-col">{{data.wrong_question_count}}</td>
              <td class="stat-col">{{data.blank_question_count}}</td>
              <td class="stat-col">{{percentCorrect(data)}}</td>
            </tr>
            <tr class="total-row">
                <td class="chapter-col">{{'total' |translate}}</td>
                <td class="stat-col">{{total.total_question}}</td>
                <td class="stat-col">{{total.correct_question_count}}</td>
                <td class="stat-col">{{total.wrong_question_count}}</td>
                <td class="stat-col">{{total.blank_question_count}}</td>
                <td class="stat-col">{{percentCorrect(total)}}</td>
            </tr>
          </tbody>
      </nz-table>
      <div class="button-group">
        <div>
          <button (click)="practiceWrong()" nz-button nzType="primary" nzSize="large" class="first-button">{{'practiceFailed' |translate}}</button>
          <button (click)="practiceBlank()" nz-button nzType="primary" nzSize="large">{{'practiceUnanswered' |translate}}</button>
        </div>
      </div>
      <div class="reset-questions">
        <a (click)="openModel()">{{'resetQuestions' |translate}}</a>
      </div>
    </div>
  </nz-card>
</div>

